import axios from "axios";
import authHeader from "../auth-header";

const main = "BytePro";
const sub = "User";

class UserService {
  getUsers() {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/All`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getUser(userId) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${userId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getUsersByOrganizationId(organizationId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/ByOrganizationId/${organizationId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  createUser(user) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}`, user, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  updateUser(userId, updatedUser) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${userId}`,
        updatedUser,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getUserByUserName(userName) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v2/${main}/${sub}/UserName/${userName}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new UserService();
